import React from 'react'
import PropTypes from 'prop-types'
import createProps from '../createProps'
import getClass from '../classNames'
import { AlignSelfType, ColumnSizeType, SIZES } from '../types'
import { isAuto, isNumeric, isString } from '../../../utils'

const propTypes = {
  ...SIZES.reduce(
    (acc, size) => ({
      ...acc,
      [size]: PropTypes.oneOfType([ColumnSizeType, PropTypes.object]),
    }),
    {},
  ),
  className: PropTypes.string,
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  children: PropTypes.node,
  order: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  offset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fluid: PropTypes.bool,
  alignSelf: AlignSelfType,
  flexGrow: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  flexShrink: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

const classMap = {
  ...SIZES.reduce(
    (acc, size) => ({
      ...acc,
      [size]: `col${size !== 's' ? '-' + size : ''}`,
    }),
    {},
  ),
  order: 'order',
  offset: 'offset',
  flexGrow: 'flex-grow',
  flexShrink: 'flex-shrink',
  alignSelf: 'align-self',
}

function getColClassNames(props) {
  const extraClasses = []

  if (props.className) {
    extraClasses.push(props.className)
  }

  const classes = Object.keys(props)
    .filter((key) => classMap[key])
    .reduce((acc, key) => {
      if (typeof props[key] === 'object' && props[key] !== null) {
        Object.entries(props[key])
          .map(([k, v]) => {
            if (k === 'span') {
              return getClass(classMap[key] + '-' + v)
            } else if (key === 'xs') {
              return getClass(k + '-' + v)
            }
            return getClass(k + '-' + key + '-' + v)
          })
          .forEach((item) => acc.push(item))
      } else {
        acc.push(
          getClass(
            isNumeric(props[key]) || isString(props[key]) || isAuto(props[key])
              ? classMap[key] + '-' + props[key]
              : classMap[key],
          ),
        )
      }
      return acc
    }, [])
  if (
    classes.length === 0 ||
    classes.filter((c) => c.indexOf('col') > -1).length === 0
  ) {
    classes.push(getClass('col'))
  }

  return classes.concat(extraClasses)
}

export function getColumnProps(props) {
  return createProps(propTypes, props, getColClassNames(props))
}

export default function Col({ tagName, as, component, ...columnProps }) {
  return React.createElement(
    tagName || as || component || 'div',
    getColumnProps(columnProps),
  )
}

Col.propTypes = propTypes
